export const SUPPORT_ONLY_SUBSCRIPTION_PLAN_REGEX = /-MNT/;
